import { useDispatch, useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { setSuccessModal } from "../../store/actions";

const SuccessModal = () => {
  const data = useSelector((state) => state.app.successModal);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(
      setSuccessModal({
        open: false,
        title: "",
        message: "",
      })
    );
  };

  return (
    <Modal onClose={onClose} onClick={onClose} open={data.open || false}>
      <div className="success-modal">
        <main>
          <IconButton onClick={onClose} className="close-icon" size="large">
            <Close />
          </IconButton>
          <h1>{data?.title}</h1>
          <p>{data?.message}</p>
          <button className="submit" onClick={onClose}>
            {data?.button || "Close"}
          </button>
        </main>
      </div>
    </Modal>
  );
};

export default SuccessModal;
